import type { LandingContent } from '@/sanity/landing-page';
import type { LandingFaqItem } from '@/utils/seo';

export const getLandingPageFaqs = (
  landingPage: Pick<LandingContent, 'sections'> | undefined,
): LandingFaqItem[] => {
  if (!landingPage) {
    return [];
  }

  return landingPage.sections.flatMap((section) => {
    if (section._type !== 'landingFaqSection') {
      return [];
    }

    return section.faqs;
  });
};
